

export default {
	'IPS': { label: 'IPS' },
	'TN': { label: 'TN' },
	'VA': { label: 'VA' },
	'OLED': { label: 'OLED' },
	'QLED': { label: 'QLED' },
}